function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.4 1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.2 6.6)",
  opacity: 0.6,
  stroke: "#25A0DA",
  strokeLinecap: "round",
  strokeWidth: 2.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.9 117.2a102.6 102.6 0 11205.2 0 102.6 102.6 0 01-205.2 0z",
  strokeDasharray: "10.3 3.1 10.3 10.3 3.1 10.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 117.2a116.5 116.5 0 11233-.1 116.5 116.5 0 01-233 .1z",
  strokeDasharray: "24.5 4.9 24.5 24.5 4.9 24.5"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.4,
  stroke: "#53BDF0",
  strokeLinecap: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M207 105.4a8.3 8.3 0 1116.7 0 8.3 8.3 0 01-16.7 0zM79.1 184.1a4.2 4.2 0 11.7 8.3 4.2 4.2 0 01-.7-8.3zM5.4 178.6a5.6 5.6 0 11.9 11.2 5.6 5.6 0 01-.9-11.2zM230.3 21.7a6.1 6.1 0 111 12.2 6.1 6.1 0 01-1-12.2zM122.9 39.4a5.5 5.5 0 11.9 11 5.5 5.5 0 01-1-11zM89.9 243.3a5 5 0 11.7 9.9 5 5 0 01-.7-10zM58.8.5a7 7 0 111 13.8 7 7 0 01-1-13.8zM261 204.6a7.5 7.5 0 111.1 14.8 7.5 7.5 0 01-1.2-14.8z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(95.3 67.2)",
  stroke: "#196FB3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M84.5 92.7v16.8c0 2-1.6 3.6-3.7 3.6H4c-2 0-3.6-1.6-3.6-3.6V3.9C.3 1.9 1.9.2 3.9.2h58c1 0 2 .4 2.6 1l19 19c.6.7 1 1.6 1 2.6v35.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.9 9.6v16.6h13.6M15 39.8h52.4M15 50.5h46.9M15 61.3h31.8M15 72h27.5M15 82.7h28.2M15 93.5h35.2"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(136.8 117.8)",
  stroke: "#145191",
  strokeWidth: 5
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M46.1 40.7l25.6 17.4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50 24.9a24.5 24.5 0 11-49.1 0 24.5 24.5 0 0149 0z"
})));

var SvgEmptyState = function SvgEmptyState(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 255,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyState, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-state.77c442c3.svg";
export { ForwardRef as ReactComponent };